import { useState, useEffect, useCallback, useMemo } from 'react'
import { inventoryService } from '../services'
import { toInventoryApiParams } from '../utils/inventoryManagementUtils'

/**
 * Fetch inventory list from URL-derived UI filters.
 * @param {{ q: string, locations: Array, page: number, limit: number }} filters
 */
export function useInventoryList(filters) {
  const [inventory, setInventory] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [totalCount, setTotalCount] = useState(0)

  const apiParams = useMemo(() => toInventoryApiParams(filters || {}), [
    filters?.q,
    filters?.page,
    filters?.limit,
    // location codes signature
    (filters?.locations || [])
      .map((entry) => (typeof entry === 'string' ? entry : entry?.code))
      .filter(Boolean)
      .join(','),
  ])

  const fetchInventory = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await inventoryService.getInventory(apiParams)
      setInventory(response.items || response.data || [])
      setTotalCount(response.pagination?.total || 0)
    } catch (err) {
      console.error('Error fetching inventory:', err)
      setError(err.response?.data?.message || 'Failed to fetch inventory')
    } finally {
      setLoading(false)
    }
  }, [apiParams])

  useEffect(() => {
    fetchInventory()
  }, [fetchInventory])

  return {
    inventory,
    loading,
    error,
    setError,
    page: filters?.page ?? 0,
    rowsPerPage: filters?.limit ?? 10,
    totalCount,
    fetchInventory,
  }
}
